import Axios from "axios";
import Firebase from "firebase";
import i18n from "../i18n";

const ConstantInfoStore = {
  namespaced: true,
  debug: true,
  state: {
    selectbox: {
      sex: [
        {
          label: i18n.t("selectListItem.sex.man"),
          value: "man"
        },
        {
          label: i18n.t("selectListItem.sex.woman"),
          value: "woman"
        },
        {
          label: i18n.t("selectListItem.sex.non"),
          value: "non"
        }
      ],
      type: [],
      allSelect: [{ value: "0000", label: "ALL", validflag: true }],
      memberStatus: [
        {
          label: i18n.t("selectListItem.memberStatus.member"),
          value: "member"
        },
        {
          label: i18n.t("selectListItem.memberStatus.unlimited"),
          value: "unlimited"
        },
        { label: i18n.t("selectListItem.memberStatus.non"), value: "non" }
      ],
      prefectures: [
        { value: "1", label: i18n.t("selectListItem.prefectures.Hokkaido") },
        { value: "2", label: i18n.t("selectListItem.prefectures.Aomori") },
        { value: "3", label: i18n.t("selectListItem.prefectures.Iwate") },
        { value: "4", label: i18n.t("selectListItem.prefectures.Miyagi") },
        { value: "5", label: i18n.t("selectListItem.prefectures.Akita") },
        { value: "6", label: i18n.t("selectListItem.prefectures.Yamagata") },
        { value: "7", label: i18n.t("selectListItem.prefectures.Fukushima") },
        { value: "8", label: i18n.t("selectListItem.prefectures.Ibaraki") },
        { value: "9", label: i18n.t("selectListItem.prefectures.Tochigi") },
        { value: "10", label: i18n.t("selectListItem.prefectures.Gunma") },
        { value: "11", label: i18n.t("selectListItem.prefectures.Saitama") },
        { value: "12", label: i18n.t("selectListItem.prefectures.Chiba") },
        { value: "13", label: i18n.t("selectListItem.prefectures.Tokyo") },
        { value: "14", label: i18n.t("selectListItem.prefectures.Kanagawa") },
        { value: "15", label: i18n.t("selectListItem.prefectures.Niigata") },
        { value: "16", label: i18n.t("selectListItem.prefectures.Toyama") },
        { value: "17", label: i18n.t("selectListItem.prefectures.Ishikawa") },
        { value: "18", label: i18n.t("selectListItem.prefectures.Fukui") },
        { value: "19", label: i18n.t("selectListItem.prefectures.Yamanashi") },
        { value: "20", label: i18n.t("selectListItem.prefectures.Nagano") },
        { value: "21", label: i18n.t("selectListItem.prefectures.Gifu") },
        { value: "22", label: i18n.t("selectListItem.prefectures.Shizuoka") },
        { value: "23", label: i18n.t("selectListItem.prefectures.Aichi") },
        { value: "24", label: i18n.t("selectListItem.prefectures.Mie") },
        { value: "25", label: i18n.t("selectListItem.prefectures.Shiga") },
        { value: "26", label: i18n.t("selectListItem.prefectures.Kyoto") },
        { value: "27", label: i18n.t("selectListItem.prefectures.Osaka") },
        { value: "28", label: i18n.t("selectListItem.prefectures.Hyogo") },
        { value: "29", label: i18n.t("selectListItem.prefectures.Nara") },
        { value: "30", label: i18n.t("selectListItem.prefectures.Wakayama") },
        { value: "31", label: i18n.t("selectListItem.prefectures.Tottori") },
        { value: "32", label: i18n.t("selectListItem.prefectures.Shimane") },
        { value: "33", label: i18n.t("selectListItem.prefectures.Okayama") },
        { value: "34", label: i18n.t("selectListItem.prefectures.Hiroshima") },
        { value: "35", label: i18n.t("selectListItem.prefectures.Yamaguchi") },
        { value: "36", label: i18n.t("selectListItem.prefectures.Tokushima") },
        { value: "37", label: i18n.t("selectListItem.prefectures.Kagawa") },
        { value: "38", label: i18n.t("selectListItem.prefectures.Ehime") },
        { value: "39", label: i18n.t("selectListItem.prefectures.Kochi") },
        { value: "40", label: i18n.t("selectListItem.prefectures.Fukuoka") },
        { value: "41", label: i18n.t("selectListItem.prefectures.Saga") },
        { value: "42", label: i18n.t("selectListItem.prefectures.Nagasaki") },
        { value: "43", label: i18n.t("selectListItem.prefectures.Kumamoto") },
        { value: "44", label: i18n.t("selectListItem.prefectures.Oita") },
        { value: "45", label: i18n.t("selectListItem.prefectures.Miyazaki") },
        { value: "46", label: i18n.t("selectListItem.prefectures.Kagoshima") },
        { value: "47", label: i18n.t("selectListItem.prefectures.Okinawa") }
      ]
    },
    rule: {
      cardRules: [
        v =>
          v === "" ||
          (/^[0-9]*$/.test(v) && v.length <= 9) ||
          i18n.t("validMessage.cardFormat")
      ],
      zipCodeRules: [
        v => !!v || i18n.t("validMessage.required"),
        v => /^[0-9]{7}$/.test(v) || i18n.t("validMessage.zipCodeFormat")
      ],
      kanaRules: [
        v => !!v || i18n.t("validMessage.required"),
        v => /^[A-Za-z]+$/.test(v) || i18n.t("validMessage.romajiFormat")
      ],
      emailRules: [
        v => !!v || i18n.t("validMessage.required"),
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          i18n.t("validMessage.emailFormat")
      ],
      emailNonRequiredRules: [
        v =>
          v === "" ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          i18n.t("validMessage.emailFormat")
      ],
      passRules: [
        v => !!v || i18n.t("validMessage.required"),
        v => (v && v.length >= 6) || i18n.t("validMessage.passwordLength")
      ],
      phoneRules: [
        v => !!v || i18n.t("validMessage.required"),
        v => /^0[0-9]{9,10}$/.test(v) || i18n.t("validMessage.phoneFormat")
      ],
      searchPhoneRules: [
        v =>
          v === "" ||
          /^0[0-9]{9,10}$/.test(v) ||
          i18n.t("validMessage.phoneFormat")
      ],
      numberRules: [
        v => String(v).trim().length > 0 || i18n.t("validMessage.required"),
        v => /^[0-9]*$/.test(v) || i18n.t("validMessage.numberFormat")
      ],
      requireRules: [v => !!v || i18n.t("validMessage.required")]
    },
    constant: {
      defaultCapcity: 10
    }
  },
  mutations: {
    async setTypeList(state, data) {
      state.selectbox.type = data;
    }
  },
  getters: {
    getCardRules(state) {
      return state.rule.cardRules;
    },
    getSexSelectObjects(state) {
      return state.selectbox.sex;
    },
    getSexData: state => value => {
      return state.selectbox.sex.find(val => {
        if (val.value === value) {
          return val;
        }
      });
    },
    getPrefecturesSelectObjects(state) {
      return state.selectbox.prefectures;
    },
    getPrefecturesData: state => value => {
      return state.selectbox.prefectures.find(val => {
        if (val.value === value) {
          return val;
        }
      });
    },
    getTypeSelectObjects(state) {
      return state.selectbox.type;
    },
    getTypeSelectValidObjects(state) {
      return state.selectbox.type.filter(data => data.validflag === true);
    },
    getTypeData: state => value => {
      return state.selectbox.type.find(val => {
        if (val.value === value) {
          return val;
        }
      });
    },
    getShowAllSelectObject(state) {
      return state.selectbox.allSelect;
    },
    getMemberStatusSelectObjects(state) {
      return state.selectbox.memberStatus;
    },
    getMemberStatusData: state => value => {
      return state.selectbox.memberStatus.find(val => {
        if (val.value === value) {
          return val;
        }
      });
    },
    getEmailRules(state) {
      return state.rule.emailRules;
    },
    getNonRequiredEmailRules(state) {
      return state.rule.emailNonRequiredRules;
    },
    getPhoneRules(state) {
      return state.rule.phoneRules;
    },
    getSearchPhoneRules(state) {
      return state.rule.searchPhoneRules;
    },
    getPasswordRules(state) {
      return state.rule.passRules;
    },
    getZipCodeRules(state) {
      return state.rule.zipCodeRules;
    },
    getKanaRules(state) {
      return state.rule.kanaRules;
    },
    getNumberRules(state) {
      return state.rule.numberRules;
    },
    getRequireRules(state) {
      return state.rule.requireRules;
    },
    getDateRules(state) {
      return state.rule.dateRules;
    },
    getDefaultCapacity(state) {
      return state.constant.defaultCapcity;
    }
  },
  actions: {
    async callTypeSelectObjects({ commit }) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let typeList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/user/typeList",
            "",
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setTypeList", typeList.data);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callAdminTypeSelectObjects({ commit }) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let typeList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/typeList",
            "",
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setTypeList", typeList.data);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callGuestTypeSelectObjects({ commit }) {
      let typeList = await Axios.post(
        process.env.VUE_APP_API_URL + "api/guest/typeList",
        "",
        {
          headers: {
            guest: true
          }
        }
      );
      commit("setTypeList", typeList.data);
    }
  }
};
export default ConstantInfoStore;
